/* KONDI PRINT - collection grid repair for language-hidden products (section 8).
   Products tagged hide_de / hide_ru / hide_uk are dropped from the grid AFTER
   Shopify has split the collection into pages, so a page ends up with fewer
   cards than products_per_page and the grid shows gaps.
   This script rebuilds the page out of the products that are actually visible
   in the current language: it loads the map of hidden positions
   (?view=kp-index) and pulls the missing cards from the neighbouring pages
   through the Section Rendering API. */
(function () {
  'use strict';

  if (window.__kpGridFill) return;
  window.__kpGridFill = true;

  var INDEX_TTL = 5 * 60 * 1000;
  var running = false;

  function params() {
    var p = new URLSearchParams(window.location.search);
    p.delete('page');
    p.delete('view');
    p.delete('section_id');
    return p;
  }

  function urlFor(extra) {
    var p = params();
    Object.keys(extra).forEach(function (k) { p.set(k, extra[k]); });
    var q = p.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }

  function currentPage() {
    var n = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    return n > 0 ? n : 1;
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }

  function loadIndex() {
    var key = 'kp-index:' + urlFor({});
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && Date.now() - cached.at < INDEX_TTL) return Promise.resolve(cached.data);
      }
    } catch (e) {}

    return getJSON(urlFor({ view: 'kp-index', page: 1 })).then(function (first) {
      var rest = [];
      for (var p = 2; p <= first.pages; p++) rest.push(p);
      return Promise.all(rest.map(function (p) {
        return getJSON(urlFor({ view: 'kp-index', page: p }));
      })).then(function (others) {
        var hidden = first.hidden.slice();
        others.forEach(function (o) { hidden = hidden.concat(o.hidden); });
        var data = { total: first.total, hidden: hidden };
        try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: data })); } catch (e) {}
        return data;
      });
    });
  }

  /* Cards of one physical page, keyed by their position in the collection. */
  function collectCards(root, physPage, per, isHidden, out) {
    var grid = root.querySelector('#product-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.collection__grid__item');
    var k = 0;
    for (var i = (physPage - 1) * per; i < physPage * per; i++) {
      if (isHidden[i]) continue;
      if (k >= cards.length) break;
      out[i] = cards[k];
      k += 1;
    }
  }

  function updateCount(visible) {
    document.querySelectorAll('#ProductCount, .counter__value').forEach(function (el) {
      if (!/\d/.test(el.textContent)) return;
      el.textContent = el.textContent.replace(/\d+(?:[.,\u00a0\u202f]\d{3})*/, String(visible));
    });
  }

  function pageNumbers(total, current) {
    var out = [];
    var from = Math.max(1, current - 2);
    var to = Math.min(total, current + 2);
    if (from > 1) { out.push(1); if (from > 2) out.push(0); }
    for (var i = from; i <= to; i++) out.push(i);
    if (to < total) { if (to < total - 1) out.push(0); out.push(total); }
    return out;
  }

  function rebuildPagination(pages, current) {
    var list = document.querySelector('.wt-pagination__list');
    if (!list) return;
    if (pages < 2) {
      var wrapper = list.closest('.wt-pagination-wrapper') || list.closest('nav');
      if (wrapper) wrapper.remove();
      return;
    }

    var arrows = list.querySelectorAll('.wt-pagination__item-arrow');
    var prevTpl = arrows[0] ? arrows[0].cloneNode(true) : null;
    var nextTpl = arrows.length > 1 ? arrows[arrows.length - 1].cloneNode(true) : null;
    if (prevTpl && !prevTpl.classList.contains('wt-pagination__item--next') && !nextTpl) {
      nextTpl = prevTpl;
      prevTpl = null;
    }

    var frag = document.createDocumentFragment();

    if (current > 1 && prevTpl) {
      prevTpl.setAttribute('href', urlFor({ page: current - 1 }));
      frag.appendChild(wrapLi(prevTpl));
    }

    pageNumbers(pages, current).forEach(function (n) {
      var el;
      if (n === 0) {
        el = document.createElement('span');
        el.className = 'wt-pagination__item';
        el.textContent = '…';
      } else if (n === current) {
        el = document.createElement('span');
        el.className = 'wt-pagination__item wt-pagination__item--current';
        el.setAttribute('aria-current', 'page');
        el.textContent = String(n);
      } else {
        el = document.createElement('a');
        el.className = 'wt-pagination__item link';
        el.setAttribute('href', urlFor({ page: n }));
        el.textContent = String(n);
      }
      frag.appendChild(wrapLi(el));
    });

    if (current < pages && nextTpl) {
      nextTpl.setAttribute('href', urlFor({ page: current + 1 }));
      frag.appendChild(wrapLi(nextTpl));
    }

    list.innerHTML = '';
    list.appendChild(frag);
  }

  function wrapLi(node) {
    var li = document.createElement('li');
    li.appendChild(node);
    return li;
  }

  function dim(grid, on) {
    if (!grid) return;
    grid.style.transition = 'opacity .15s';
    grid.style.opacity = on ? '0' : '';
    if (on) window.setTimeout(function () { grid.style.opacity = ''; }, 2000);
  }

  function show(card) {
    card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen', 'scroll-trigger--cancel');
    card.removeAttribute('data-cascade');
    card.style.opacity = '';
    card.style.transform = '';
    return card;
  }

  function run() {
    if (running) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var per = parseInt(grid.getAttribute('data-kp-per') || '0', 10);
    var sectionId = grid.getAttribute('data-id');
    if (!per || !sectionId) return;
    /* One page only: every visible product is already on screen, the counter
       is the only thing that still counts the hidden ones. */
    if (!document.querySelector('.wt-pagination__list')) {
      if (window.location.pathname.indexOf('/collections/') !== -1) {
        updateCount(grid.querySelectorAll('.collection__grid__item').length);
      }
      return;
    }

    running = true;
    var page = currentPage();

    loadIndex().then(function (index) {
      if (!index || !index.hidden || !index.hidden.length) return;

      var isHidden = {};
      index.hidden.forEach(function (i) { isHidden[i] = true; });

      var visible = [];
      for (var i = 0; i < index.total; i++) if (!isHidden[i]) visible.push(i);

      updateCount(visible.length);

      var pages = Math.max(1, Math.ceil(visible.length / per));
      if (page > pages) {
        window.location.replace(urlFor({ page: pages }));
        return;
      }

      var want = visible.slice((page - 1) * per, page * per);
      if (!want.length) return;

      var have = {};
      collectCards(document, page, per, isHidden, have);

      var needed = {};
      want.forEach(function (pos) {
        var p = Math.floor(pos / per) + 1;
        if (p !== page) needed[p] = true;
      });

      if (Object.keys(needed).length) dim(grid, true);

      var jobs = Object.keys(needed).map(function (p) {
        return fetch(urlFor({ page: p, section_id: sectionId }), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            collectCards(doc, parseInt(p, 10), per, isHidden, have);
          });
      });

      return Promise.all(jobs).then(function () {
        var ready = want.filter(function (pos) { return have[pos]; });
        if (ready.length !== want.length) return;

        var frag = document.createDocumentFragment();
        want.forEach(function (pos, i) {
          var card = show(document.importNode(have[pos], true));
          card.style.setProperty('--animation-order', String(i + 1));
          frag.appendChild(card);
        });

        var olds = grid.querySelectorAll('.collection__grid__item');
        if (olds.length) {
          olds[0].parentNode.insertBefore(frag, olds[0]);
          Array.prototype.forEach.call(olds, function (el) { el.remove(); });
        } else {
          grid.appendChild(frag);
        }
        rebuildPagination(pages, page);
      });
    }).catch(function () {}).then(function () {
      running = false;
      dim(document.getElementById('product-grid'), false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('facets:change', function () {
    window.setTimeout(run, 0);
  });
})();
